/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 내 계약 목록 조회
 */
export const contractsControllerGetMyContractsQueryPageDefault = 1;

export const contractsControllerGetMyContractsQueryLimitDefault = 20;
export const contractsControllerGetMyContractsQueryLimitMax = 100;

export const contractsControllerGetMyContractsQuerySortByDefault = "created_at";
export const contractsControllerGetMyContractsQuerySortOrderDefault = "desc";

export const contractsControllerGetMyContractsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(contractsControllerGetMyContractsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(contractsControllerGetMyContractsQueryLimitMax)
      .default(contractsControllerGetMyContractsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(contractsControllerGetMyContractsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(contractsControllerGetMyContractsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    statuses: zod
      .array(zod.enum(["IN_PROGRESS", "COMPLETED", "CANCELED"]))
      .optional(),
  })
  .strict();

export const contractsControllerGetMyContractsResponseTwoDataItemsItemQuoteRequestOneResponseCountMin = 0;

export const contractsControllerGetMyContractsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().uuid().describe("계약 ID (UUID)"),
              contractNumber: zod
                .string()
                .describe("계약 번호 (UI 표시용 - SE 제외)"),
              status: zod
                .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                .describe("계약 상태"),
              totalAmount: zod.number().describe("총 금액"),
              pdfUrl: zod
                .string()
                .nullable()
                .describe("계약서 PDF URL (생성 중이면 null)"),
              supplier: zod
                .object({
                  name: zod.string().describe("공급자 회사명"),
                })
                .strict()
                .describe("공급자 정보"),
              quoteRequest: zod
                .object({
                  id: zod.string().uuid().describe("견적 요청 ID"),
                  requestNumber: zod
                    .string()
                    .describe("견적 요청 번호 (UI 표시용 - SE 제외)"),
                  projectName: zod.string().describe("프로젝트명"),
                  status: zod
                    .enum([
                      "TEMP_SAVE",
                      "WAITING_APPROVAL",
                      "IN_PROGRESS",
                      "ON_HOLD",
                      "CLOSED",
                      "CANCELLED",
                    ])
                    .describe("견적 요청 상태"),
                  deadline: zod
                    .string()
                    .datetime({})
                    .nullable()
                    .describe("마감일 (ISO 8601)"),
                  responseCount: zod
                    .number()
                    .min(
                      contractsControllerGetMyContractsResponseTwoDataItemsItemQuoteRequestOneResponseCountMin,
                    )
                    .describe("응답 수"),
                })
                .strict()
                .describe("견적 요청 정보 (참조용)"),
              quoteResponseVersionId: zod
                .string()
                .uuid()
                .nullish()
                .describe(
                  "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고(`externalRef`), 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다. 계약 목록에서 [카드결제]/[카드영수증] 을 그리는 재료.",
                ),
              settlementStatus: zod
                .enum(["PENDING", "COMPLETED", "DEFERRED"])
                .describe("정산상태"),
              paymentMethod: zod
                .enum(["CARD", "BANK_TRANSFER"])
                .nullish()
                .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
              paymentChannel: zod
                .enum(["cash", "card"])
                .nullish()
                .describe(
                  "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 위 `paymentMethod` 는 **결제 거래**의 수단(DIRECT/CMARKET_CARD 등)이라 이것과 다른 축이다 — 현금/카드 배지는 반드시 이 필드로 그릴 것.",
                ),
              taxInvoiceStatus: zod
                .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                .nullish()
                .describe(
                  "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨.",
                ),
              taxInvoiceTargetId: zod
                .object({})
                .nullish()
                .describe(
                  "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키.",
                ),
              buyer: zod
                .object({
                  name: zod.string().optional().describe("구매자명"),
                })
                .strict()
                .nullish()
                .describe("발주자 정보"),
              constructionType: zod
                .object({
                  value: zod.string().describe("내부 코드"),
                  label: zod.string().describe("표시 라벨"),
                })
                .strict()
                .nullish()
                .describe("공사 유형 (공사 카테고리인 경우)"),
              spaceType: zod
                .object({
                  value: zod.string().describe("내부 코드"),
                  label: zod.string().describe("표시 라벨"),
                })
                .strict()
                .nullish()
                .describe("공사 장소 (공사 카테고리인 경우)"),
              constructionArea: zod
                .object({
                  value: zod.string().describe("내부 코드"),
                  label: zod.string().describe("표시 라벨"),
                })
                .strict()
                .nullish()
                .describe("공사 면적 (공사 카테고리인 경우)"),
              cancellationReason: zod
                .string()
                .nullish()
                .describe(
                  "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
                ),
              cancellationRequestedAt: zod
                .string()
                .datetime({})
                .nullish()
                .describe(
                  "계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)",
                ),
              cancellationRequestedBy: zod
                .enum(["buyer", "supplier"])
                .nullish()
                .describe(
                  "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
                ),
              canceledAt: zod
                .string()
                .datetime({})
                .nullish()
                .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
              createdAt: zod
                .string()
                .datetime({})
                .describe("계약 생성 일시 (ISO 8601)"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 계약서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */
export const contractsControllerDownloadPdfParams = zod
  .object({
    id: zod.coerce.string().uuid().describe("계약 ID"),
  })
  .strict();

export const contractsControllerDownloadPdfResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        pdfUrl: zod.string().describe("생성된 PDF의 Public URL"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 계약서 PDF 스트리밍 (당사자 전용, 만료 없는 주소)
 */
export const contractsControllerStreamPdfParams = zod
  .object({
    id: zod.coerce.string().uuid().describe("계약 ID"),
  })
  .strict();

/**
 * @summary 계약 취소 확인서 PDF 다운로드 URL 조회 (즉시 생성 지원)
 */
export const contractsControllerDownloadCancellationPdfParams = zod
  .object({
    id: zod.coerce.string().uuid().describe("계약 ID"),
  })
  .strict();

export const contractsControllerDownloadCancellationPdfResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        pdfUrl: zod.string().describe("생성된 PDF의 Public URL"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 계약 생성 (PDF 자동 생성)
 */
export const contractsControllerCreateContractBodyItemsItemNameMax = 255;

export const contractsControllerCreateContractBodyItemsItemUnitPriceMin = 0;

export const contractsControllerCreateContractBodyItemsItemUnitMax = 10;

export const contractsControllerCreateContractBodyItemsItemSpec1Max = 255;

export const contractsControllerCreateContractBodyItemsItemSpec2Max = 255;

export const contractsControllerCreateContractBodyItemsItemSpec3Max = 255;

export const contractsControllerCreateContractBodyItemsItemAmountMin = 0;

export const contractsControllerCreateContractBodyItemsItemItemCodeMax = 100;

export const contractsControllerCreateContractBodyItemsItemManufacturerMax = 100;

export const contractsControllerCreateContractBodyItemsItemBrandMax = 100;

export const contractsControllerCreateContractBody = zod
  .object({
    paymentTransactionId: zod
      .string()
      .optional()
      .describe("결제 거래 ID (MOID). 직접 결제 시 생략 가능."),
    quoteResponseVersionId: zod.string().uuid().describe("견적 응답 버전 ID"),
    totalAmount: zod.number().describe("총 금액"),
    taxAmount: zod.number().optional().describe("세금 (선택사항)"),
    items: zod
      .array(
        zod
          .object({
            name: zod
              .string()
              .max(contractsControllerCreateContractBodyItemsItemNameMax)
              .describe("품목명 (필수)"),
            unitPrice: zod
              .number()
              .min(contractsControllerCreateContractBodyItemsItemUnitPriceMin)
              .describe("단가 (부가세 포함, 원 단위)"),
            unit: zod
              .string()
              .max(contractsControllerCreateContractBodyItemsItemUnitMax)
              .describe("단위 (예: EA, 박스, 세트)"),
            spec1: zod
              .string()
              .max(contractsControllerCreateContractBodyItemsItemSpec1Max)
              .optional()
              .describe("규격 1 (예: A4, 500ml)"),
            spec2: zod
              .string()
              .max(contractsControllerCreateContractBodyItemsItemSpec2Max)
              .optional()
              .describe("규격 2 - 재질/타입 (예: 80g, 스테인리스)"),
            spec3: zod
              .string()
              .max(contractsControllerCreateContractBodyItemsItemSpec3Max)
              .optional()
              .describe("규격 3 - 패키징 (예: 2500매/박스)"),
            quantity: zod
              .number()
              .min(1)
              .describe("수량 (견적응답 전용 - items 테이블에는 없음)"),
            amount: zod
              .number()
              .min(contractsControllerCreateContractBodyItemsItemAmountMin)
              .describe("품목별 총액 (단가 x 수량, 견적응답 전용)"),
            itemCode: zod
              .string()
              .max(contractsControllerCreateContractBodyItemsItemItemCodeMax)
              .optional()
              .describe("상품코드 (items 테이블 선택사항)"),
            manufacturer: zod
              .string()
              .max(
                contractsControllerCreateContractBodyItemsItemManufacturerMax,
              )
              .optional()
              .describe("제조사 (items 테이블 선택사항)"),
            brand: zod
              .string()
              .max(contractsControllerCreateContractBodyItemsItemBrandMax)
              .optional()
              .describe("브랜드 (items 테이블 선택사항)"),
            itemId: zod
              .string()
              .optional()
              .describe("시스템 아이템 ID (자동 견적 매칭용)"),
          })
          .strict(),
      )
      .describe("계약 항목"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
    paymentChannel: zod
      .enum(["cash", "card"])
      .optional()
      .describe(
        "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 미전달 시 미상(NULL)으로 저장된다.",
      ),
  })
  .strict();

/**
 * postpaid 로 체결된 계약이 실제 결제 완료된 시점에 프론트가 호출한다. paymentTransactionId 로 갱신하며, 이미 결제된 계약은 no-op(200).
 * @summary 후불결제 계약 결제 완료 처리 (buyer 전용)
 */
export const contractsControllerMarkContractPaidParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

/**
 * @summary 계약 — 씨마켓 카드결제 가능 여부(현재 상태)
 */
export const contractsControllerGetCardPaymentStatusParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const contractsControllerGetCardPaymentStatusResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        cmarketCardSignupRequired: zod
          .boolean()
          .describe(
            "씨마켓 카드결제 가맹 가입 안내를 띄워야 하는가. 씨마켓 결제창으로 받아야 하는 카드 계약인데 공급사가 아직 가맹이 아닐 때만 true. 세모 안심결제 계약·현금 계약·판정할 수 없는 경우는 false.",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 특정 계약의 상세 정보를 조회합니다.
 * @summary 계약 조회 (PDF 상태 확인)
 */
export const contractsControllerGetContractParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const contractsControllerGetContractResponseTwoDataItemsItemNameMax = 255;

export const contractsControllerGetContractResponseTwoDataItemsItemUnitPriceMin = 0;

export const contractsControllerGetContractResponseTwoDataItemsItemUnitMax = 10;

export const contractsControllerGetContractResponseTwoDataItemsItemSpec1Max = 255;

export const contractsControllerGetContractResponseTwoDataItemsItemSpec2Max = 255;

export const contractsControllerGetContractResponseTwoDataItemsItemSpec3Max = 255;

export const contractsControllerGetContractResponseTwoDataItemsItemAmountMin = 0;

export const contractsControllerGetContractResponseTwoDataItemsItemItemCodeMax = 100;

export const contractsControllerGetContractResponseTwoDataItemsItemManufacturerMax = 100;

export const contractsControllerGetContractResponseTwoDataItemsItemBrandMax = 100;

export const contractsControllerGetContractResponseTwoDataIsPrepaidDefault = true;

export const contractsControllerGetContractResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().uuid().describe("계약 ID"),
        paymentTransactionId: zod.string().describe("결제 거래 ID"),
        contractNumber: zod.string().describe("계약번호"),
        totalAmount: zod.number().describe("총 금액"),
        taxAmount: zod.number().optional().describe("세금 (선택사항)"),
        status: zod
          .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
          .describe("계약 상태"),
        pdfUrl: zod.string().nullable().describe("계약서 PDF URL"),
        pdfGeneratedAt: zod
          .string()
          .datetime({})
          .describe("계약서 PDF 생성 일시 (ISO 8601)"),
        items: zod
          .array(
            zod
              .object({
                name: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemNameMax,
                  )
                  .describe("품목명 (필수)"),
                unitPrice: zod
                  .number()
                  .min(
                    contractsControllerGetContractResponseTwoDataItemsItemUnitPriceMin,
                  )
                  .describe("단가 (부가세 포함, 원 단위)"),
                unit: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemUnitMax,
                  )
                  .describe("단위 (예: EA, 박스, 세트)"),
                spec1: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemSpec1Max,
                  )
                  .optional()
                  .describe("규격 1 (예: A4, 500ml)"),
                spec2: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemSpec2Max,
                  )
                  .optional()
                  .describe("규격 2 - 재질/타입 (예: 80g, 스테인리스)"),
                spec3: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemSpec3Max,
                  )
                  .optional()
                  .describe("규격 3 - 패키징 (예: 2500매/박스)"),
                quantity: zod
                  .number()
                  .min(1)
                  .describe("수량 (견적응답 전용 - items 테이블에는 없음)"),
                amount: zod
                  .number()
                  .min(
                    contractsControllerGetContractResponseTwoDataItemsItemAmountMin,
                  )
                  .describe("품목별 총액 (단가 x 수량, 견적응답 전용)"),
                itemCode: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemItemCodeMax,
                  )
                  .optional()
                  .describe("상품코드 (items 테이블 선택사항)"),
                manufacturer: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemManufacturerMax,
                  )
                  .optional()
                  .describe("제조사 (items 테이블 선택사항)"),
                brand: zod
                  .string()
                  .max(
                    contractsControllerGetContractResponseTwoDataItemsItemBrandMax,
                  )
                  .optional()
                  .describe("브랜드 (items 테이블 선택사항)"),
                itemId: zod
                  .string()
                  .optional()
                  .describe("시스템 아이템 ID (자동 견적 매칭용)"),
              })
              .strict(),
          )
          .describe("계약 항목"),
        supplier: zod
          .object({
            id: zod.string().uuid().describe("공급자 ID"),
            name: zod.string().describe("공급자 회사명"),
            ceoName: zod.string().describe("대표자명"),
            businessNumber: zod.string().describe("사업자등록번호"),
            address: zod.string().optional().describe("회사 주소"),
            phone: zod.string().optional().describe("회사 전화번호"),
            email: zod.string().optional().describe("공급자 이메일"),
            managerName: zod.string().optional().describe("담당자명"),
            managerPhone: zod.string().optional().describe("담당자 전화번호"),
            companySealUrl: zod.string().optional().describe("회사 직인 URL"),
            bankName: zod.string().optional().describe("은행명"),
            bankAccountNumber: zod.string().optional().describe("계좌번호"),
            bankAccountHolder: zod.string().optional().describe("예금주"),
          })
          .strict()
          .describe("공급자 정보"),
        description: zod.string().optional().describe("견적 설명/비고"),
        createdAt: zod
          .string()
          .datetime({})
          .describe("계약 생성 일시 (ISO 8601)"),
        updatedAt: zod
          .string()
          .datetime({})
          .describe("계약 수정 일시 (ISO 8601)"),
        canceledAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("계약 취소 일시 (status=CANCELED일 때만 존재)"),
        cancellationReason: zod
          .string()
          .nullish()
          .describe(
            "계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)",
          ),
        cancellationRequestedAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)"),
        cancellationRequestedBy: zod
          .enum(["buyer", "supplier"])
          .nullish()
          .describe(
            "계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.",
          ),
        completedAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe("구매확정 일시 (status=COMPLETED일 때만 존재)"),
        projectName: zod.string().optional().describe("프로젝트명 (거래명)"),
        categoryType: zod
          .enum(["product", "construction", "manufacturing", "used"])
          .optional()
          .describe("카테고리 유형"),
        quoteRequestId: zod.string().uuid().optional().describe("견적 요청 ID"),
        quoteResponseVersionId: zod
          .string()
          .uuid()
          .optional()
          .describe(
            "견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다.",
          ),
        chatRoomId: zod
          .string()
          .uuid()
          .optional()
          .describe("채팅방 ID (채팅 시작용)"),
        chatMessageId: zod
          .string()
          .uuid()
          .optional()
          .describe("채팅 메시지 ID"),
        reviewId: zod
          .string()
          .uuid()
          .optional()
          .describe("리뷰 ID (작성된 리뷰가 있는 경우)"),
        paymentMethod: zod
          .enum(["CARD", "BANK_TRANSFER"])
          .optional()
          .describe("결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)"),
        settlementStatus: zod
          .enum(["PENDING", "COMPLETED", "DEFERRED"])
          .describe("정산상태"),
        refundStatus: zod
          .string()
          .nullish()
          .describe(
            "환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)",
          ),
        rejectionReason: zod
          .string()
          .nullish()
          .describe("환불 반려 사유 (refundStatus=REJECTED일 때만 존재)"),
        buyer: zod
          .object({
            name: zod.string().optional().describe("구매자명"),
            company: zod.string().optional().describe("발주기관명"),
            representativeName: zod
              .string()
              .optional()
              .describe("발주기관 대표자"),
            businessNumber: zod
              .string()
              .optional()
              .describe("발주기관 사업자등록번호"),
            address: zod.string().optional().describe("발주기관 주소"),
            phone: zod.string().optional().describe("구매자 전화번호"),
            email: zod.string().optional().describe("구매자 이메일"),
          })
          .strict()
          .nullish()
          .describe("발주자 정보"),
        deliveryAddress: zod
          .object({
            id: zod.string().describe("주소 ID (UUID)"),
            userId: zod.string().describe("사용자 ID (UUID)"),
            label: zod
              .string()
              .optional()
              .describe("주소 라벨 (회사, 집, 창고 등)"),
            isDefault: zod.boolean().describe("기본 배송지 여부"),
            postalCode: zod.string().describe("우편번호 (5자리 숫자)"),
            province: zod.string().describe("시/도 (광역시 또는 도 단위)"),
            city: zod.string().describe("시/군/구 (기초자치단체)"),
            district: zod.string().optional().describe("읍/면/동 (선택사항)"),
            streetAddress: zod.string().describe("도로명 주소"),
            addressDetail: zod
              .string()
              .optional()
              .describe("상세 주소 (건물명, 동/호 등)"),
            recipientName: zod.string().optional().describe("수령인 이름"),
            recipientPhone: zod
              .string()
              .optional()
              .describe("수령인 연락처 (휴대폰 또는 일반전화)"),
            createdAt: zod
              .string()
              .optional()
              .describe("생성일 (ISO 8601 형식)"),
            updatedAt: zod
              .string()
              .optional()
              .describe("수정일 (ISO 8601 형식)"),
          })
          .strict()
          .nullish()
          .describe("배송지 정보"),
        isPrepaid: zod
          .boolean()
          .describe(
            "결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제).",
          ),
        paidAt: zod
          .string()
          .datetime({})
          .nullish()
          .describe(
            "결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.",
          ),
        paymentChannel: zod
          .enum(["cash", "card"])
          .nullish()
          .describe(
            "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
          ),
        taxInvoiceStatus: zod
          .enum(["REQUESTED", "ISSUED", "CANCELLED"])
          .nullish()
          .describe(
            "씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.",
          ),
        taxInvoiceTargetId: zod
          .object({})
          .nullish()
          .describe(
            "씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 계약 취소 (환불 처리)
 */
export const contractsControllerCancelContractParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const contractsControllerCancelContractBody = zod
  .object({
    reason: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "계약 취소 사유 (canonical). reason 또는 refund_reason 중 최소 하나는 필수.",
      ),
    refund_reason: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "[Deprecated] 취소 사유의 구버전 필드명. reason 필드로 마이그레이션 예정. reason이 없을 때만 fallback으로 사용됨.",
      ),
    refund_bank: zod
      .string()
      .optional()
      .describe("환불 받을 은행명 (현금 결제 & 발주기관 요청 시에만 유효)"),
    refund_account_number: zod
      .string()
      .optional()
      .describe("환불 받을 계좌번호 (현금 결제 시 필수)"),
    refund_account_holder: zod
      .string()
      .optional()
      .describe("환불 계좌 예금주 (현금 결제 시 필수)"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

/**
 * 계약을 최종 완료 처리하고 리뷰를 작성합니다.
 * @summary 계약 구매확정 (리뷰 작성 필수)
 */
export const contractsControllerCompleteContractParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const contractsControllerCompleteContractBodyDetailedReviewMin = 10;

export const contractsControllerCompleteContractBody = zod
  .object({
    positiveAspects: zod
      .array(zod.string())
      .describe("좋은 점 태그 (최대 6개)"),
    negativeAspects: zod
      .array(zod.string())
      .optional()
      .describe("아쉬운 점 태그 (최대 4개)"),
    detailedReview: zod
      .string()
      .min(contractsControllerCompleteContractBodyDetailedReviewMin)
      .describe("상세 후기 (최소 10자)"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

export const contractsControllerCompleteContractResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 구매자가 계약 취소를 요청합니다.
 * @summary 계약 취소 요청 (구매자 → 판매자 승인 대기)
 */
export const contractsControllerRequestCancellationParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const contractsControllerRequestCancellationBody = zod
  .object({
    reason: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "계약 취소 사유 (canonical). reason 또는 refund_reason 중 최소 하나는 필수.",
      ),
    refund_reason: zod
      .string()
      .min(1)
      .optional()
      .describe(
        "[Deprecated] 취소 사유의 구버전 필드명. reason 필드로 마이그레이션 예정. reason이 없을 때만 fallback으로 사용됨.",
      ),
    refund_bank: zod
      .string()
      .optional()
      .describe("환불 받을 은행명 (현금 결제 & 발주기관 요청 시에만 유효)"),
    refund_account_number: zod
      .string()
      .optional()
      .describe("환불 받을 계좌번호 (현금 결제 시 필수)"),
    refund_account_holder: zod
      .string()
      .optional()
      .describe("환불 계좌 예금주 (현금 결제 시 필수)"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

export const contractsControllerRequestCancellationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 판매자가 채팅방에서 취소 요청을 승인합니다.
 * @summary 계약 취소 승인 (판매자)
 */
export const contractsControllerConfirmCancellationParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const contractsControllerConfirmCancellationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * 판매자가 구매자의 계약 취소 요청을 반려합니다.
 * @summary 계약 취소 반려 (판매자)
 */
export const contractsControllerRejectCancellationParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const contractsControllerRejectCancellationBody = zod
  .object({
    rejectionReason: zod.string(),
  })
  .strict();

export const contractsControllerRejectCancellationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod.object({}).optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
